// extracted by mini-css-extract-plugin
module.exports = {"tile":"ServiceTile_tile__H2M7H","text":"ServiceTile_text__7ABYT","title":"ServiceTile_title__IeuQd","price":"ServiceTile_price__hdxf_"};